import { ContentType, request } from "../api";

import { baseParams } from "../common";

export const getPriceCalendar = async (data = {}, params = {}) =>
  request({
    path: "/price-calendar",
    method: "POST",
    body: { ...baseParams, ...data },
    type: ContentType.Json,
    format: "json",
    ...params,
  });
